
import { create } from "zustand";

type ImagenStoreProps = {
  imagen: File | null;
  setImagen: (m: File | null) => void;
}

export const useImagenStore = create<ImagenStoreProps>((set) => ({
  imagen: null,
  setImagen: (m) => {
    set({
      imagen: m
    })
  }
}))

